import { render, staticRenderFns } from "./componentNav.vue?vue&type=template&id=f97df814&scoped=true"
import script from "./componentNav.vue?vue&type=script&lang=js"
export * from "./componentNav.vue?vue&type=script&lang=js"
import style0 from "./componentNav.vue?vue&type=style&index=0&id=f97df814&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97df814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f97df814')) {
      api.createRecord('f97df814', component.options)
    } else {
      api.reload('f97df814', component.options)
    }
    module.hot.accept("./componentNav.vue?vue&type=template&id=f97df814&scoped=true", function () {
      api.rerender('f97df814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentNav.vue"
export default component.exports